import React, { useState } from 'react'
import Icon from '../icon/icon'
import styles from './wikiInfo.jcss'
import type { WikiInfoConfig, WikiInfoProps } from './WikiInfo.types'

export const WikiInfo = ({ blockKey, blockSubKey, infoKey, size }: WikiInfoProps) => {
    const [open, setOpen] = useState(false)
    const wiki = (window.spconfig.wikiInfo as unknown) as WikiInfoConfig | undefined
    const info = wiki?.[blockKey]?.[blockSubKey]?.[infoKey]

    if (!info) {
        return null
    }

    return (
        <>
            <div
                onClick={() => {
                    if (info.resourceOpenType === 'external') {
                        window.open(info.url)

                        return
                    }

                    setOpen(true)
                }}
            >
                <Icon type={'info'} size={size ? size : 14} />
            </div>
            {open && (
                <div className={styles.wikiModal}>
                    <Icon
                        type={'close'}
                        size={24}
                        className={styles.close}
                        color={'white'}
                        onClick={() => setOpen(false)}
                    />
                    <div className={styles.iframeWrapper}>
                        <iframe className={styles.iframe} src={info.url}></iframe>
                    </div>
                </div>
            )}
        </>
    )
}
